export default {

    methods: {
        currencyFormat(value) {
            let formatter = new Intl.NumberFormat('en-GB', {
                style: 'currency',
                currency: 'GBP',
            });

            return formatter.format(value).replace(/\D00$/, '');
        },
    }
}
